<template>
  <v-card>
    <v-card-text class="pa-4">
      <div class="subtitle-2">
        {{ confirmationText }}
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn v-if="!disableButton" text color="success" @click="$emit('saveDialog')">Yes</v-btn>
      <v-btn text color="error" @click="$emit('closeDialog')">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  name: "ConfirmationDialog",

  props: {
    disableButton: {
      type: Boolean,
      default: false,
    },
    confirmationText: {
      type: String,
      required: true,
    },
  },
};
</script>
